import { render, staticRenderFns } from "./ExamSimulationDes.vue?vue&type=template&id=6bc60c0a&scoped=true&"
import script from "./ExamSimulationDes.vue?vue&type=script&lang=js&"
export * from "./ExamSimulationDes.vue?vue&type=script&lang=js&"
import style0 from "./ExamSimulationDes.vue?vue&type=style&index=0&id=6bc60c0a&lang=scss&scoped=true&"
import style1 from "./ExamSimulationDes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc60c0a",
  null
  
)

export default component.exports